import { isTMSTheme } from 'services/ui';
import { ColorsLearnIT, ColorsTMS } from './colors';

export * from './common';
export * from './resume';

const Colors = isTMSTheme() ? ColorsTMS : ColorsLearnIT;

export { Colors };
